<template>
  <DropdownModule
    v-if="isOwner"
    icon="icon-more-horizontal text-24"
    :width="150"
    :top-position="position"
    append-to-body
    class="anim-opacity md:opacity-0 group-hover:opacity-100"
    :class="{'md:opacity-100': showMenu}"
    remove-optional-top-gap
    :background="isDarkMode ? 'bg-sidebar' : 'bg-white'"
    is-auto-menu-position
    @click="showMenu = true"
    @close="showMenu = false"
  >
    <div>
      <div class="hover:bg-selection rounded-t-4 group-scope text-15">
        <ButtonModule
          text="Edit"
          :prefix="`icon-edit mr-15 ${isDarkMode ? 'text-main-color' : ''} ${isTwilightTheme ? 'group-scope-hover:text-app-color' : ''}`"
          class="p-10 w-full"
          @click.stop="toggleEdit"
        />
      </div>
      <div class="hover:bg-selection group-scope text-15">
        <ButtonModule
          text="Delete"
          :prefix="`icon-delete mr-15 ${isDarkMode ? 'text-main-color' : ''} ${isTwilightTheme ? 'group-scope-hover:text-app-color' : ''}`"
          class="p-10 w-full"
          @click.stop="deleteMessage"
        />
      </div>
    </div>
  </DropdownModule>
</template>

<script>
import { defineComponent, ref, computed } from 'vue'
import { useStore } from 'vuex'

import ButtonModule from '@/components/shared/form-controls/ButtonModule'
import DropdownModule from '@/components/shared/form-controls/DropdownModule'

export default defineComponent({
  components: { ButtonModule, DropdownModule },

  props: {
    message: Object,
    classes: [String, Array],
    highlighted: { type: Boolean, default: false },
    position: { type: String, default: '30px' }
  },

  emits: ['deleteMessage', 'toggleEdit'],

  setup (props, { emit }) {
    const { state, getters } = useStore()

    const showMenu = ref(false)

    const isDarkMode = computed(() => getters.isDarkMode)
    const isTwilightTheme = computed(() => getters.isTwilightTheme)

    const isOwner = computed(() => props.message.user?.id === state.profile.user.id)

    function deleteMessage () {
      emit('deleteMessage')
    }

    function toggleEdit () {
      emit('toggleEdit')
    }

    return {
      // data
      showMenu,
      // computed
      isOwner,
      isDarkMode,
      isTwilightTheme,
      // function
      toggleEdit,
      deleteMessage
    }
  }
})
</script>
